module.exports = __webpack_public_path__ + "img/g1.78b4152c.jpeg";